import React from 'react';
import { Link } from 'react-router-dom';

export default function ConsultationCancel() {
  return (
    <div className="min-h-screen bg-black text-white flex items-center justify-center px-6">
      <div
        data-testid="consultation-cancel-card"
        className="max-w-xl w-full bg-gray-900 border border-gray-700 rounded-2xl p-10 text-center"
      >
        <h1 className="text-3xl font-bold text-amber-400 mb-3">Consultation cancelled</h1>
        <p className="text-gray-300 mb-6">
          No payment was taken. Whenever you're ready, the door is open.
        </p>
        <Link
          to="/"
          className="inline-block px-5 py-2 rounded-full bg-amber-400 text-black font-semibold hover:bg-amber-300 transition-colors"
        >
          Return to HumanCodex University
        </Link>
      </div>
    </div>
  );
}
